import { useState, useEffect } from "react";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

export const CookieBanner = ({ lang }) => {
  const [isVisible, setIsVisible] = useState(false);

  const content = {
    pt: {
      title: "Utilizamos cookies",
      description: "Este site utiliza cookies para melhorar a sua experiência. Ao continuar, concorda com a nossa política de privacidade.",
      accept: "Aceitar",
      decline: "Recusar",
    },
    en: {
      title: "We use cookies",
      description: "This site uses cookies to improve your experience. By continuing, you agree to our privacy policy.",
      accept: "Accept",
      decline: "Decline",
    },
  };

  const t = content[lang] || content.pt;

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie-consent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] bg-[#0A0A0A] border-t border-white/10"
      style={{ animation: "slideUp 0.3s ease-out" }}
    >
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }
      `}</style>
      <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3 text-center sm:text-left">
          <Cookie className="w-5 h-5 text-[#C5A059] hidden sm:block flex-shrink-0" />
          <p className="text-sm text-[#A3A3A3]">
            <span className="text-[#E5E5E5] font-medium">{t.title}:</span> {t.description}
          </p>
        </div>
        
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button
            onClick={handleDecline}
            variant="ghost"
            size="sm"
            data-testid="cookie-decline"
            className="text-[#A3A3A3] hover:text-[#E5E5E5] hover:bg-white/5 px-4"
          >
            {t.decline}
          </Button>
          <Button
            onClick={handleAccept}
            size="sm"
            data-testid="cookie-accept"
            className="bg-[#C5A059] text-[#050505] hover:bg-[#D4B068] px-4"
          >
            {t.accept}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
